import React, { Component } from "react"
import { connect } from 'react-redux'
import moment from 'moment'
import {
    clearSearchDirectoryInfoAction,
} from '../../redux/actions/MasterAction'
import {
    setKeyValueAction,
    clearModalAction
} from '../../redux/actions/ModalEmployeeAction'

import {
    updateGR_DetailAction,
    updateGR_ItemAction,
    updateGR_ServiceAction,
    updateGR_ServiceLineAction,
    updateGR_ItemAccountAssignmentAction,
    updateGR_ServiceAccountAssignmentAction,
    updateGR_ItemModalAction,
    updateGR_ServiceLineModalAction,
    selectItemGR_ServiceAction
} from '../../redux/actions/GRAction'
import {
    saveTransactionAction,
    getPODetailOriginalAction,
} from '../../redux/actions/MainAction'
import { Input, DatePicker } from "../core"
import utilityHelper from '../../helpers/helperUtil'

import GRItemList from './GRItemList'
import GRServiceList from './GRServiceList'
import ServiceLineList from './ServiceLineList'

import { Storage } from "../../configs"
import { msg } from "../Notifications/MsgBox/index.js"
import validateUtil from "../../helpers/validateUtil.js"
import { startLoadingAction, stopLoadingAction } from "../../redux/actions/AppAction.js"
import tagsConfigHelper from "../../helpers/tagsConfigHelper.js"

const numeral = require('numeral')

class GoodsReceive extends Component {

    constructor(props) {
        super(props)

        this.state = {
            // ...props,
            local_t_PO_DETAIL: {},
            local_t_GR_DETAIL: {},
            local_t_GR_ITEM: [],
            local_t_GR_SERVICE: [],
            local_t_GR_SERVICELINE: [],
            local_t_GR_ITEM_ACCOUNT_ASSIGNMENT: [],
            local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: [],
            local_t_MR_IR_DESCRIPTION: [],
            overall_limit: 0,
            ol_currency: "THB",
            expected_value: 0,
            ev_currency: "THB",
            actual_value: 0,
            av_currency: "THB",
            total_received_value: 0.00,
            trv_currency: "THB",
            serviceItemNo: "",
            purchase_checkall: false,
            service_checkall: false,
            serviceline_checkall: false,
            transaction_no: ""
        }

        this.handleChange = this.handleChange.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        //this.calTotalReceived = this.calTotalReceived.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)

        window.onDeleteServiceItem = this.handleDeleteServiceItem.bind(this)
        window.onDeleteServiceLine = this.handleLoadServiceLineByAction.bind(this)
        window.onLoadServiceLineBySave = this.handleLoadServiceLineByAction.bind(this)

        window.onUserSearchEmployeeSelected = this.handleUserSearchEmployeeSelected.bind(this)
        this.sumTotalReceivedValue = this.sumTotalReceivedValue.bind(this)
        this.onSelectServiceLine = this.onSelectServiceLine.bind(this)
        this.onHandleChangeServiceLine = this.onHandleChangeServiceLine.bind(this)
    }

    handleChange(event, commited) {
        // event.preventDefault()
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;
        const { local_t_GR_DETAIL } = this.state

        //check date
        if (target.className) {
            if ((target.className.indexOf("js-datepicker") > -1 || target.className.indexOf("js-datepicker-all") > -1) && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    }
                }
            }
        }

        if (valid) {
            
            if (name == 'post_date' && value == '') {
                value = local_t_GR_DETAIL.post_date
            }

            if (name == 'document_date' && value == '') {
                value = local_t_GR_DETAIL.document_date
            }
           
            this.setState({
                local_t_GR_DETAIL: {
                    ...this.state.local_t_GR_DETAIL,
                    [name]: value
                }
            })

            this.setState({
                [name]: value
            })

            //this.calTotalReceived()
            if (commited === true) {
                this.props.updateGR_Detail(value, name)
            }
            

        } else {
            return
        }
    }

    // calTotalReceived() {

    //     let totalreceive = 0

    //     const { 
    //         serviceItemNo,
    //         local_t_GR_SERVICELINE 
    //     } = this.state

    //     let local_serviceline = local_t_GR_SERVICELINE.filter((data) => {
    //         return data.service_item_no && (data.service_item_no + '') === (serviceItemNo + '') && data.checked == 1
    //     })

    //     local_serviceline && local_serviceline.map((row, index) => {
    //         if (row.checked == 1 && Number(row.service_item_no) === Number(serviceItemNo)) {
    //             let gross_price = utilityHelper.parseFloat(row.gross_price)
    //             let receive_qty = utilityHelper.parseFloat(row.receive_qty)
    //             let _totalreceive = utilityHelper.parseFloat(totalreceive)
    //             totalreceive = (gross_price * receive_qty) + _totalreceive
    //             totalreceive = numeral(totalreceive).format('0,0.00')
    //         }
    //     })

    //     this.setState({ total_received_value: totalreceive })
    //  }

    sumTotalReceivedValue(local_serviceItemNo) {

        let totalreceive = 0

        const { t_GR_SERVICELINE } = this.props

        let local_serviceline = t_GR_SERVICELINE.filter((data) => {
            return data.service_item_no && (data.service_item_no + '') === (local_serviceItemNo + '') && data.checked == 1
        })

        local_serviceline && local_serviceline.map((row, index) => {
            if (row.checked == 1 && Number(row.service_item_no) === Number(local_serviceItemNo)) {
                let numeral = require('numeral');
                let gross_price = utilityHelper.parseFloat(row.gross_price)
                let receive_qty = utilityHelper.parseFloat(row.receive_qty)
                let _totalreceive = utilityHelper.parseFloat(totalreceive)
                totalreceive = (gross_price * receive_qty) + _totalreceive
                totalreceive = numeral(totalreceive).format('0,0.00')
            }
        })

        this.setState({ total_received_value: totalreceive })


        window.emitter.emit("sumTotalReceivedValueEmitter", {
            t_serviceItemNo: local_serviceItemNo,
            t_total_value: totalreceive
        })

        return totalreceive
    }


    handleDeleteServiceItem(objserviceItem) {
        const {
            serviceItemNo,
            local_t_GR_SERVICE,
            local_t_GR_SERVICELINE
        } = this.state

        if (serviceItemNo && Number(serviceItemNo) === Number(objserviceItem.service_item_no)) {
            const _service = local_t_GR_SERVICE.find(f => f.checked === 1 && Number(f.service_item_no) !== Number(objserviceItem.service_item_no))
            if (_service) {
                this.setState({
                    serviceItemNo: _service.service_item_no
                })

                let _serviceline = local_t_GR_SERVICELINE.filter((data) => {
                    return data.service_item_no && (data.service_item_no + '') === (serviceItemNo + '')
                })

                if (_serviceline) {
                    this.setState({
                        serviceline_render: _serviceline,
                        showServiceLine: true
                    })
                }
            }
            else {
                this.setState({
                    showServiceLine: false
                })
            }
        }
        else if (serviceItemNo === '') {
            this.setState({
                showServiceLine: false
            })
        }
    }

    handleLoadServiceLineByAction(objserviceline) {
        const {
            serviceItemNo,
            local_t_GR_SERVICE,
            local_t_GR_SERVICELINE
        } = this.state

        if (serviceItemNo) {
            let _serviceline = objserviceline.filter((data) => {
                return data.service_item_no && (data.service_item_no + '') === (serviceItemNo + '')
            })

            if (_serviceline) {

                let totalreceive = 0
                _serviceline && _serviceline.map((row, index) => {
                    if (row.checked == 1 && Number(row.service_item_no) === Number(serviceItemNo)) {
                        let gross_price = utilityHelper.parseFloat(row.gross_price)
                        let receive_qty = utilityHelper.parseFloat(row.receive_qty)
                        let _totalreceive = utilityHelper.parseFloat(totalreceive)
                        totalreceive = (gross_price * receive_qty) + _totalreceive
                        totalreceive = numeral(totalreceive).format('0,0.00')
                    }
                })
                this.setState({
                    local_t_GR_SERVICELINE: objserviceline,
                    total_received_value: totalreceive
                })
            }

        }
        else {
            const _service = local_t_GR_SERVICE.find(f => f.checked === 1)
            this.setState({
                serviceItemNo: _service ? _service.service_item_no : ''
            })
        }

    }

    handleChangePage(event, newPage, pageName) {
        this.setState({
            [pageName]: newPage
        })
    }

    handleChangeRowsPerPage(event, pageName, rowsPerPageName) {
        this.setState({
            [rowsPerPageName]: +event.target.value,
            [pageName]: 0
        })
    }

    getStorageLocation_ByPlant(plantcode) {
        // console.log("getStorageLocation_ByPlant: ", plantcode)
        let result = null
        const { storage_locations } = this.props

        result = storage_locations && storage_locations.filter(f => f.plant === plantcode)
        if (result) {
            result = utilityHelper.toSelectList(result, "sloC_NAME", "sloc")
        }

        // console.log(result)
        return result
    }

    getUnitUOM() {
        let result = null
        const { unit_uom } = this.props

        if (unit_uom) {
            //result = utilityHelper.toSelectList(unit_uom, "commercial", "commercial")
            result = utilityHelper.toSelectList_CombineFields(unit_uom, "commercial", "uniT_TEXT", "commercial")
        }
        return result
    }

    componentWillReceiveProps(nextProps) {
        let {
            transaction_uid,
            t_GR_ITEM,
            t_GR_SERVICE,
            t_GR_SERVICELINE,
        } = this.props

        let {
            serviceItemNo,
            serviceline_render,
            showServiceLine
        } = this.state

        console.group("GoodsReceive.componentWillReceiveProps()")
       
        console.groupEnd()

        //if (transaction_uid != nextProps.transaction_uid) {
        this.setState({
            local_t_PO_DETAIL: { ...nextProps.t_PO_DETAIL },
            local_t_GR_DETAIL: { ...nextProps.t_GR_DETAIL },
            local_t_GR_ITEM: [...nextProps.t_GR_ITEM],
            local_t_GR_SERVICE: [...nextProps.t_GR_SERVICE],
            local_t_GR_SERVICELINE: [...nextProps.t_GR_SERVICELINE],
            local_t_GR_ITEM_ACCOUNT_ASSIGNMENT: [...nextProps.t_GR_ITEM_ACCOUNT_ASSIGNMENT],
            local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: [...nextProps.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT],
            local_t_MR_IR_DESCRIPTION: [...nextProps.t_MR_IR_DESCRIPTION]
        })
        //}
     
        if (transaction_uid != nextProps.transaction_uid && nextProps.t_PO_DETAIL.transaction_no == null) {
            this.setState({ serviceItemNo: "" })
        }

    }

    async handleSubmit(event, source, nexttab) {
        await this.props.startLoading()

        // const {
        //         local_t_PO_DETAIL,
        //         local_t_GR_DETAIL,
        //         local_t_GR_ITEM,
        //         local_t_GR_SERVICE,
        //         local_t_GR_SERVICELINE,
        //         local_t_GR_ITEM_ACCOUNT_ASSIGNMENT,
        //         local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT
        //         }=this.state

        // let po_no = local_t_PO_DETAIL && local_t_PO_DETAIL.po_contract_no;
        // const role = Storage.getRole()

        let checkErrors = []
        // let _checkQty = validateUtil.checkReceiveQty(local_t_GR_ITEM, local_t_GR_SERVICE, local_t_GR_SERVICELINE, po_no)
        // if(_checkQty !== null){
        //     checkErrors.push(_checkQty)
        // }

        // let _checkTotal = validateUtil.checkTotalReceiveVal(local_t_GR_SERVICE, local_t_GR_SERVICELINE)
        // if(_checkTotal !== null){
        //     checkErrors.push(_checkTotal)
        // }

        // let _checkGoodsRecipient = validateUtil.checkGoodsRecipientVal(local_t_GR_ITEM)
        // if (_checkGoodsRecipient !== null) {
        //     checkErrors.push(_checkGoodsRecipient)
        // }

        //  if (role === 'R') {
        //      let _checkDummyAssect = validateUtil.checkDummyAssect(local_t_GR_ITEM, local_t_GR_SERVICE, local_t_GR_SERVICELINE, local_t_GR_ITEM_ACCOUNT_ASSIGNMENT, local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT)
        //      if (_checkDummyAssect !== null) {
        //          checkErrors.push(_checkDummyAssect)
        //      }
        //  }

        //  let _checkSelectItem = validateUtil.checkSelectItem(local_t_GR_ITEM, local_t_GR_SERVICE, local_t_GR_SERVICELINE)
        //  if (_checkSelectItem !== null) {
        //      checkErrors.push(_checkSelectItem)
        //  }

        //  let gritem = local_t_GR_ITEM.filter(i => i.checked == 1)
        //  gritem.forEach((item) => {
        //      let docTypegritem = utilityHelper.getDocType(po_no, item.a, item.i, item.material, null)
        //      var tagInfoStorageLocation = tagsConfigHelper.findTagConfig("gr.item.storage_location", docTypegritem)
        //      if (tagInfoStorageLocation) {
        //          if (tagInfoStorageLocation.required) {
        //              if (item.storage_location === null) {
        //                  checkErrors.push({ error_message: "Items: " + item.item_no + " กรุณาระบุ Storage Location" })
        //              }
        //          }
        //      }
        //  })

        //  if (local_t_GR_DETAIL) {
        //      if (local_t_GR_DETAIL.period_start_date 
        //         && local_t_GR_DETAIL.period_end_date 
        //         && local_t_GR_DETAIL.period_start_date > local_t_GR_DETAIL.period_end_date) {
        //          checkErrors.push({ error_message: "ข้อมูล Period End มีค่ามากว่า Period Start กรุณาตรวจสอบข้อมูล" })
        //      }

        //  }
        let error_messages = []

        if (checkErrors.length > 0) {
            checkErrors.forEach((error) => {
                error_messages.push(error.error_message)
            })
            msg.error(error_messages.join('<br/>'))
            this.props.stopLoading()
        }
        else {
            await this.props.onHandleSubmit(event, source, null, null, nexttab);
        }
    }
    
    handleUserSearchEmployeeSelected(key, empCode, empName, empData) {

        if (!empCode || !empName) return
        //  var name = empName.split(" ");

        if (key == "T_GR_DETAIL") {
            this.setState({
                local_t_GR_DETAIL: {
                    ...this.state.local_t_GR_DETAIL,
                    prsp_intern: empCode
                }
            })
            this.props.updateGR_Detail(empCode, 'prsp_intern')
        }
    }

    searchEmployeeModal(empCode, empName) {
        console.log("openSearch");

        this.props.clearSearchDirectoryInfo();
        this.props.clearModal();

        this.props.setKeyValue('T_GR_DETAIL', empCode, empName)

        window.$('#searchEmployeeModal').modal('show');
    }

    formatDisplayEmployee(empCode, empName) {
        if (empCode !== null && empCode !== '')
            return empCode
        else
            return ''
    }

    onSelectServiceLine(index, isCheck) {
        let { t_GR_SERVICELINE } = this.props

        t_GR_SERVICELINE[index].checked = isCheck

        this.setState({
            local_t_GR_SERVICELINE: t_GR_SERVICELINE
        })

    }

    onHandleChangeServiceLine(name, value, index) {

        let { t_GR_SERVICELINE } = this.props
        let current = t_GR_SERVICELINE[index]
        current[name] = value
        this.setState({ local_t_GR_SERVICELINE: t_GR_SERVICELINE })

    }

    render() {
        const {
            viewMode,
            unit_uom,
            storage_locations,
            docementType,
            t_GR_SERVICE,
        } = this.props

        let {
            serviceItemNo,
            local_t_PO_DETAIL,
            local_t_GR_DETAIL,
            local_t_GR_ITEM,
            local_t_GR_SERVICE,
            local_t_GR_SERVICELINE,
            total_received_value,
            local_t_GR_ITEM_ACCOUNT_ASSIGNMENT,
            local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
            overall_limit
        } = this.state


        // console.group("GoodsRecieve.index.render()")
        // console.log("local_t_PO_DETAIL:")
        // console.log(local_t_PO_DETAIL)
        // console.log("local_t_GR_DETAIL:")
        // console.log(local_t_GR_DETAIL)
        // console.log("local_t_GR_ITEM:")
        // console.log(local_t_GR_ITEM)
        // console.log("local_t_GR_SERVICE:")
        // console.log(local_t_GR_SERVICE)
        // console.log("local_t_GR_SERVICELINE:")
        // console.log(local_t_GR_SERVICELINE)
        // console.groupEnd()

        let po_no = local_t_PO_DETAIL.po_contract_no;

        let is_contract = utilityHelper.checkIsContract(po_no);

        let docTypeItem = ""
        if (local_t_GR_ITEM.length > 0) {
            let grItem = local_t_GR_ITEM[0]
            if (grItem) {
                docTypeItem = utilityHelper.getDocType(po_no, grItem.a, grItem.i, grItem.material, null)
            }
        }

        let docTypeService = ""
        if (local_t_GR_SERVICE.length > 0) {
            let grItem = local_t_GR_SERVICE[0]
            if (grItem) {
                docTypeService = utilityHelper.getDocType(po_no, grItem.a, grItem.i, grItem.material, grItem.overall_limit)
            }
        }

        let docTypeServiceLine = ""
        if (serviceItemNo !== "" && serviceItemNo !== null) {
            let grItem = local_t_GR_SERVICE.find(f => f.service_item_no == serviceItemNo)
            if (grItem) {
                docTypeServiceLine = utilityHelper.getDocType(po_no, grItem.a, grItem.i, grItem.material, grItem.overall_limit)
            }
        }

        let requiredPurchase = local_t_GR_ITEM.find(f => f.checked == 1) ? true : false
        let requiredService = local_t_GR_SERVICE.find(s => s.checked == 1) ? true : false

        return (
            <div className="rrs-container-wrap collapse" id="rrsTab3" aria-labelledby="rrsGoodsReceive" data-parent="#invoiceRecordingSystem">
                <div className="rrs-container">
                    {/* Start content tab 2 */}
                    {local_t_PO_DETAIL.po_contract_no && (<div className="rrs-detail pt-1 pb-3">
                        <div className="row">
                            <div className="col-md-4">
                                <h3>PO / Contract No. {local_t_PO_DETAIL.po_contract_no}</h3>
                            </div>
                            <div className="col-md-8 text-right">
                                <h3>Vendor : {local_t_PO_DETAIL.vendor_code + " " + local_t_PO_DETAIL.vendor_name}</h3>
                            </div>
                        </div>
                    </div>)}

                    <div className="rrs-detail py-1">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="rrs-form">
                                    <label htmlFor="invoice_date_gr" id="lbl-gr_header_document_date" className="rrs-label mb-0"><span className="required">*</span> Document Date</label>
                                    <div className="rrs-detail-data">
                                        <label htmlFor="cc" id="lblsub-gr_header_document_date" className="rrs-label"> (วันที่ ใบแจ้งหนี้/ใบกำกับภาษี)</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <DatePicker
                                            value={local_t_GR_DETAIL.document_date
                                                ? moment(local_t_GR_DETAIL.document_date).format('DD/MM/YYYY')
                                                : ""}
                                            name="document_date"
                                            id="gr_document_date"
                                            onChange={this.handleChange}
                                            onBlur={(event) => { this.handleChange(event, true) }}
                                            doctype={"P*"}
                                            tagid="gr.header.Document_Date"
                                            readOnly={true}
                                            viewMode={viewMode}
                                            validate_required={requiredPurchase || requiredService}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="rrs-form">
                                    <label htmlFor="gr_post_date" id="lbl-gr_header_posting_date" className="rrs-label mb-0"><span className="required">*</span> Posting Date</label>
                                    <div className="rrs-detail-data">
                                        <label htmlFor="cc" id="lblsub-gr_header_posting_date" className="rrs-label"> (วันที่หน่วยงานจัดหาบันทึกข้อมูล GR)</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <DatePicker
                                            value={local_t_GR_DETAIL.post_date
                                                ? moment(local_t_GR_DETAIL.post_date).format('DD/MM/YYYY')
                                                : ""}
                                            name="post_date"
                                            id="gr_post_date"
                                            onChange={this.handleChange}
                                            onBlur={(event) => { this.handleChange(event, true) }}
                                            doctype={"P*"}
                                            tagid="gr.header.Posting_Date"
                                            viewMode={viewMode}
                                            readOnly={true}
                                            validate_required={requiredPurchase || requiredService}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                  
                    {local_t_GR_ITEM.length > 0 && (
                        <div className="rrs-detail py-1">
                            {/* <div className="row gr-delNote-headText"> */}
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="rrs-form">
                                        <label htmlFor="gr_delivery_note" id="lbl-gr.purchase_header.Delivery_Note" className="rrs-label mb-0"><span className="required">*</span> Delivery Note</label>
                                        <div className="rrs-detail-data">
                                            <label htmlFor="cc" id="lblsub-gr.purchase_header.Delivery_Note" className="rrs-label">(หมายเลขใบส่งของ/ใบแจ้งหนี้/ใบกำกับภาษี)</label>
                                        </div>
                                        <div className="rrs-detail-data">
                                            <Input
                                                name="delivery_note"
                                                defaultValue={local_t_GR_DETAIL.delivery_note || ''}
                                                id="gr_delivery_note"
                                                doctype={"P*"}
                                                tagid="gr.purchase_header.Delivery_Note"
                                                maxlength="16"
                                                //onChange={this.handleChange}
                                                onBlur={(event) => { this.handleChange(event, true) }}
                                                viewMode={viewMode}
                                                validate_required={requiredPurchase}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="rrs-form">
                                        <label id="lbl-gr_purchase_header_header_text" htmlFor="gr_po_header_text" className="rrs-label mb-0">Header Text</label>
                                        <div className="rrs-detail-data">
                                            <label htmlFor="cc" id="lblsub-gr.purchase_header.Header_Text" className="rrs-label"> (รายละเอียด/งวดงาน)</label>
                                        </div>
                                        <div className="rrs-detail-data">
                                            <Input
                                                name="po_header_text"
                                                defaultValue={local_t_GR_DETAIL.po_header_text || ''}
                                                id="gr_po_header_text"
                                                maxlength="25"
                                                //onChange={this.handleChange}
                                                onBlur={(event) => { this.handleChange(event, true) }}
                                                doctype={"P*"}
                                                tagid="gr.purchase_header.Header_Text"
                                                viewMode={viewMode}
                                                validate_required={requiredPurchase}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>)}

                    {/* รายการรับสินค้า */}
                    <GRItemList
                        viewMode={viewMode}
                        po_no={po_no}
                        docTypeItem={docTypeItem}
                        is_contract={is_contract}
                        t_GR_ITEM={local_t_GR_ITEM}
                        t_GR_ITEM_ACCOUNT_ASSIGNMENT={local_t_GR_ITEM_ACCOUNT_ASSIGNMENT}
                        t_GR_SERVICE={local_t_GR_SERVICE}
                        storage_locations={storage_locations}
                        onHandleDeleteGRItem={this.props.onHandleDelete}
                    />

                    {t_GR_SERVICE && t_GR_SERVICE.length > 0 && (<div className="rrs-detail py-1">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="rrs-form">
                                    <label id="lbl-gr.service_header.Reference" htmlFor="gr_reference" className="rrs-label"><span className="required">*</span>Reference</label>
                                    <div className="rrs-detail-data">
                                        <label htmlFor="cc" id="lblsub-gr_header_reference" className="rrs-label"> (เลขที่ใบแจ้งหนี้/ใบกำกับภาษี)</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <Input
                                            name="reference"
                                            defaultValue={local_t_GR_DETAIL.reference || ''}
                                            id="gr_reference"
                                            maxlength="16"
                                            //onChange={this.handleChange}
                                            onBlur={(event) => { this.handleChange(event, true) }}
                                            doctype={"S*"}
                                            tagid="gr.service_header.Reference"
                                            autoComplete="off"
                                            viewMode={viewMode}
                                            validate_required={requiredService}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="rrs-form">
                                    <label htmlFor="gr_doc_text" id="lbl-gr_service_header_doc_text" className="rrs-label">Doc. Text</label>
                                    <div className="rrs-detail-data">
                                        <label htmlFor="cc" id="lblsub-gr_header_reference" className="rrs-label">(คำบรรยายชื่องานบริการ)</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <Input
                                            name="doc_text"
                                            defaultValue={local_t_GR_DETAIL.doc_text || ''}
                                            id="gr_doc_text"
                                            maxlength="25"
                                            //onChange={this.handleChange}
                                            onBlur={(event) => { this.handleChange(event, true) }}
                                            doctype={"S*"}
                                            tagid="gr.service_header.doc_text"
                                            viewMode={viewMode}
                                            validate_required={requiredService}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4">
                                <div className="rrs-form">
                                    <div className="rrs-detail-data content-hide">
                                        <label htmlFor="cc" id="lblsub-gr_header_reference" className="rrs-label">|</label>
                                    </div>
                                    <label htmlFor="gr_service_loc" id="lbl-gr_service_header_service_loc" className="rrs-label"><span className="required">*</span>Service Loc</label>
                                    <div className="rrs-detail-data">
                                        <Input
                                            name="service_loc"
                                            defaultValue={local_t_GR_DETAIL.service_loc || ''}
                                            id="gr_service_loc"
                                            maxlength="25"
                                            //onChange={this.handleChange}
                                            onBlur={(event) => { this.handleChange(event, true) }}
                                            doctype={"S*"}
                                            tagid="gr.service_header.Service_Loc"
                                            viewMode={viewMode}
                                            validate_required={requiredService}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="rrs-form">
                                    <label htmlFor="gr_prsp_intern" id="lbl-gr.service_header.prsp_intern" className="rrs-label">
                                        {/* <span className="required">*</span>  */}
                                        PRsp. Intern.</label>
                                    <div className="rrs-detail-data">
                                        <label htmlFor="cc" id="lblsub-gr.service_header.prsp_intern" className="rrs-label">(รหัสผู้รับงาน)</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <Input
                                            name="prsp_intern"
                                            className="form-control form-control-search-2"
                                            // defaultValue={local_t_GR_DETAIL.prsp_intern || ''}
                                            value={this.formatDisplayEmployee(local_t_GR_DETAIL.prsp_intern)}
                                            id="gr_prsp_intern"
                                            //onChange={this.handleChange}
                                            // onBlur={(event) => { this.handleChange(event, true) }}
                                            onClick={() => this.searchEmployeeModal("prsp_intern", "prsp_intern")}
                                            doctype={"S*"}
                                            tagid="gr.service_header.prsp_intern"
                                            maxlength="12"
                                            viewMode={viewMode}
                                            validate_required={requiredService}
                                            readOnly={true && !viewMode}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4">
                                <div className="rrs-form">
                                    <label htmlFor="Period-start" id="lbl-gr_service_header_period_start" className="rrs-label">Period - Start</label>
                                    <div className="rrs-detail-data">
                                        <DatePicker
                                            value={local_t_GR_DETAIL.period_start_date
                                                ? moment(local_t_GR_DETAIL.period_start_date).format('DD/MM/YYYY')
                                                : ""}
                                            name="period_start_date"
                                            id="gr_period_start_date"
                                            onChange={this.handleChange}
                                            onBlur={(event) => { this.handleChange(event, true) }}
                                            doctype={"S*"}
                                            tagid="gr.service_header.Period_Start"
                                            viewMode={viewMode}
                                            validate_required={requiredService}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="rrs-form">
                                    <label htmlFor="Period-end" id="lbl-gr_service_header_period_end" className="rrs-label">Period - End</label>
                                    <div className="rrs-detail-data">
                                        <DatePicker
                                            value={local_t_GR_DETAIL.period_end_date
                                                ? moment(local_t_GR_DETAIL.period_end_date).format('DD/MM/YYYY')
                                                : ""}
                                            name="period_end_date"
                                            id="gr_period_end_date"
                                            onChange={this.handleChange}
                                            onBlur={(event) => { this.handleChange(event, true) }}
                                            doctype={"S*"}
                                            tagid="gr.service_header.Period_End"
                                            showsdayall={"All"}
                                            viewMode={viewMode}
                                            validate_required={requiredService}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>)}

                    {/* รายการรับบริการ */}
                    <GRServiceList
                        viewMode={viewMode}
                        po_no={po_no}
                        docTypeService={docTypeService}
                        is_contract={is_contract}
                        t_GR_SERVICE={local_t_GR_SERVICE}
                        t_GR_SERVICELINE={local_t_GR_SERVICELINE}
                        t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT={local_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT}
                        onServiceItemSelected={(value) => this.setState({ serviceItemNo: value })}
                        onHandleDeleteServiceItem={this.props.onHandleDelete}
                        sumTotal_Received_Value={total_received_value}
                        onSumTotalReceivedValue={this.sumTotalReceivedValue}
                        getOverAllLimit ={(value) => this.setState({ overall_limit: value })}
                    />

                    {/* Service Line */}

                    <ServiceLineList
                        viewMode={viewMode}
                        is_contract={is_contract}
                        docTypeServiceLine={docTypeServiceLine}
                        t_GR_SERVICE={local_t_GR_SERVICE}
                        t_GR_SERVICELINE={local_t_GR_SERVICELINE}
                        serviceItemNo={serviceItemNo}
                        unit_uom={unit_uom}
                        docementType={docementType}
                        onHandleDeleteServiceLine={this.props.onHandleDelete}
                        onSumTotalReceivedValue={this.sumTotalReceivedValue}
                        onSelectServiceLine={this.onSelectServiceLine}
                        onHandleChangeServiceLine={this.onHandleChangeServiceLine}
                        setOverAllLimit = {overall_limit}
                    />

                    {(po_no != null) && (
                        <div className="rrs-detail py-1" style={{ visibility: this.props.viewMode ? "hidden" : "visible" }}>
                            <div className="row sp-table-content-footer">
                                <div className="col-12 sp-header-button-panel2 justify-content-center">
                                    {local_t_GR_DETAIL.transaction_no !== "" && (
                                        <a className="sp-btn-icon" onClick={() => { this.props.onHandleDelete("Transaction") }}>
                                            <i className="icon btn-order-delete" />
                                            <span className="sp-btn-icon-label2">Delete</span>
                                        </a>
                                    )}
                                    <a className="sp-btn-icon" onClick={(event) => { this.handleSubmit(event, this, "rrsTab4") }} >
                                        <i className="icon btn-order-savedraft" />
                                        <span className="sp-btn-icon-label">Save</span>
                                    </a>
                                    {/* <a href="#" className="sp-btn-icon" onClick={(event) => { this.props.onValidateGR() }} >
                                    <i className="icon btn-order-savedraft" />
                                    <span className="sp-btn-icon-label">Validate GR</span>
                                </a> */}
                                </div>
                            </div>
                        </div>
                    )}
                    {/* End content tab 2 */}
                </div >
            </div >
        )
    }

}

const mapStateToProps = state => {
    const { MasterRedux, MainRedux } = state
    return {
        viewMode: MainRedux.viewMode,
        transaction_no: MainRedux.transaction_no,
        transaction_uid: MainRedux.transaction_uid,
        transaction: MainRedux.transaction,
        t_PO_DETAIL: MainRedux.t_PO_DETAIL,
        t_GR_DETAIL: MainRedux.t_GR_DETAIL,
        t_GR_ITEM: MainRedux.t_GR_ITEM,
        t_GR_SERVICE: MainRedux.t_GR_SERVICE,
        t_GR_SERVICELINE: MainRedux.t_GR_SERVICELINE,
        t_GR_ITEM_ACCOUNT_ASSIGNMENT: MainRedux.t_GR_ITEM_ACCOUNT_ASSIGNMENT,
        t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: MainRedux.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
        t_MR_IR_DESCRIPTION: MainRedux.t_MR_IR_DESCRIPTION,
        storage_locations: MasterRedux.storage_locations,
        currency_code_data: MasterRedux.currency_codes,
        itemModal: MainRedux.itemModal,
        serviceLineModal: MainRedux.serviceLineModal,
        unit_uom: MasterRedux.unit_uom,
        docementType: MainRedux.docementType,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        saveTransaction: (transaction) => dispatch(saveTransactionAction(transaction)),
        updateGR_Detail: (data, fieldName) => dispatch(updateGR_DetailAction(data, fieldName)),
        updateGR_Item: (data, index = "", fieldName = "", clear = false) => dispatch(updateGR_ItemAction(data, index, fieldName, clear)),
        updateGR_Service: (data, index = "", fieldName = "", clear = false) => dispatch(updateGR_ServiceAction(data, index, fieldName, clear)),
        updateGR_ServiceLine: (data, index = "", fieldName = "", clear = false) => dispatch(updateGR_ServiceLineAction(data, index, fieldName, clear)),
        updateGR_ItemAccountAssignment: (data, index = "", fieldName = "") => dispatch(updateGR_ItemAccountAssignmentAction(data, index, fieldName)),
        updateGR_ServiceAccountAssignment: (data, index = "", fieldName = "") => dispatch(updateGR_ServiceAccountAssignmentAction(data, index, fieldName)),
        updateGR_ItemModal: (data) => dispatch(updateGR_ItemModalAction(data)),
        updateGR_ServiceLineModal: (data) => dispatch(updateGR_ServiceLineModalAction(data)),
        selectItemGR_Service: (data) => dispatch(selectItemGR_ServiceAction(data)),
        getPODetailOriginal: (poNo, unitCode) => dispatch(getPODetailOriginalAction(poNo, unitCode)),
        startLoading: () => dispatch(startLoadingAction()),
        stopLoading: () => dispatch(stopLoadingAction()),
        setKeyValue: (table, empCode, empName) => dispatch(setKeyValueAction(table, empCode, empName)),
        clearModal: () => dispatch(clearModalAction()),
        clearSearchDirectoryInfo: () => dispatch(clearSearchDirectoryInfoAction()),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GoodsReceive)